/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        echo.init({
          offset: 1000,
          throttle: 250,
          unload: false,
          callback: function (element, op) {
            // console.log(element, 'has been', op + 'ed');
            var myEvent = new CustomEvent("lazyLoadComplete");
            document.body.dispatchEvent(myEvent);
          }
        });
        // add this function for a fixed header
        /* $(window).scroll(function(){
          if ($(window).scrollTop() >= 5) {
            $('body').addClass('fixed-header');
          }
          else {
            $('body').removeClass('fixed-header');
          }
        }); */
        // slick on the homepage if needed
        /* $('.slick').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }); */

        /**** START ACCORDION CODE ****/

        $('.accordion-label').click(function() {
          var content = this.nextElementSibling;
          $('.accordion-label').not($(this)).removeClass('active').attr('aria-expanded', 'false');
          $('.accordion-content').css('max-height', '');
          if ($(this).is('.active')) {
            $(this).toggleClass('active').attr('aria-expanded', 'false');
            heightVal = '0';
          } else {
            $(this).toggleClass('active').attr('aria-expanded', 'true');
            heightVal = content.scrollHeight + "px";
          }
          $(content).css('max-height', heightVal);
        });

        // js for ekko lightbox (image gallery)
        $(document).on('click', '[data-toggle="lightbox"]', function(event) {
          event.preventDefault();
          $(this).ekkoLightbox({
            alwaysShowClose: true,
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
         /* product js for slick carousel thing */
        $('.product-image-gallery').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: false,
          arrows: false,
          fade: true,
          asNavFor: '.product-image-gallery-nav',
          speed: 200
        });
        $('.product-image-gallery-nav').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          asNavFor: '.product-image-gallery',
          dots: false,
          centerMode: false,
          centerPadding: 0,
          focusOnSelect: true,
          speed: 200
        });

        /**** START TAB CODE ****/
        $('.tab-set li').on('click', function(e){
          var tab_id = $(this).attr('data-tab');
          tab_id = tab_id.replace(/\s+/g, '-').toLowerCase();
          $('.tab-set li').removeClass('active');
          $('.tab-content div').removeClass('active');
          $(this).addClass('active');
          $("#tab_"+tab_id).addClass('active');
        });
        /* links to tabbed content at the top of product pages */
        $('.top-tab-links > li > a').on('click', function(e){
          var a_anchor = this.getAttribute("href");

          a_anchor = a_anchor.replace("#","");
          var a_tab = document.getElementById(a_anchor);
          var a_content = a_tab.getAttribute("data-tab");

          var a_content_div = document.getElementById("tab_" + a_content);
          var a_content_siblings = $(a_content_div).siblings('div');
          $(a_content_siblings).removeClass('active');
          $(a_content_div).addClass('active');

          $a_siblings = $(a_tab).siblings('li');
          $a_siblings.removeClass('active');

          // TODO : add finder function for the content div, set active class

          $(a_tab).addClass('active').trigger('tabChanged');
        });
        /**** END TAB CODE ****/

        /**** smooth anchor scrolling ****/
        var $root = $('html, body');

        $('a[href^="#"]').click(function () {
          $root.animate({
            scrollTop: $( $.attr(this, 'href') ).offset().top
          }, 500);

          return false;
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        
        $('.testimonial-slideshow').slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Carousels page
    'carousels': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Accordions and Tabs page
    'accordions_tabs': {
      init: function() {

        /* var d = document,
        accordionLabels = d.getElementsByClassName("accordion-label"),
        i;

        for (i = 0; i < accordionLabels.length; i++) {
          accordionLabels[i].onclick = function() {

            this.classList.toggle("active");

            var content = this.nextElementSibling;
            if (this.getAttribute('aria-expanded') === 'true') {
              content.style.maxHeight = null;
              this.setAttribute('aria-expanded', 'false');
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
              this.setAttribute('aria-expanded', 'true');
            }
          };
        }
        */
        /**** END ACCORDION CODE ****/

      },
      finalize: function() {

      }
    },
    'product': {
      init: function() {
        
      },
      finalize: function() {

      }
    },
    'upgrades': {  // Serial number form
      init: function() {
		//console.log('NEW TEST');  
		$('#sernum').keyup(function () { 
			//this.value = this.value.replace(/[^0-9\.]/g,'');
			this.value = this.value.replace(/[^0-9]/g,'');
		});
		$("#submitupgrade").click(function(event){
			//console.log('success');
			var error_free = true;
			var ser_num = $("#sernum").val();
			//alert (ser_num);
			var ser_num_length = ser_num.length; 
			//alert (ser_num_length);			
			if (ser_num_length < 10) {
				error_free=false;
			}
			if (!error_free){
				alert('Please enter your 10 digit serial number');
				event.preventDefault(); 
				//console.log(ser_num);
			}
			else{
				//alert('No errors: Form will be submitted');
				var formData = {
            		'actk'         : 'yvg6f5-gw1q4jb37',
					'SerialNumber' : $('input[name=sernum]').val()
				};
				$.ajax({  // send a copy of the data to Insite.
					type  : 'POST',
					cache : false,
					url   : 'https://www.insitemetrics.com/imv2/uRMJ/uniformv2.php',
					data  : formData
				});
			}
		});		
       
      },
      finalize: function() {

      }
    },	
    // Gallery/Portfolio page
    'galleryportfolio': {
      init: function() {

        // Size grid parents by content
        function masonrySizer() {
          $.each($('.grid').find('img'), function(i,v) {
            var $ele = $(this),
                $parent = $ele.parent();

            $parent.height('auto'); // reset parent height or expanding upwards will bug out due to ele height restricting image height

            var $eleHeight = $ele.height(),
                $eleWidth = $ele.width();

            $parent.height($eleHeight); // Set parent height to image height
          });
        }

        function startMasonry() {
          $('.grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer'
          });
        }

        $( window ).resize(function() {
          masonrySizer();
        });

        $(document).ready(function(){
          masonrySizer();
        });


        document.body.addEventListener("lazyLoadComplete", startMasonry, false);


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'calculator': {
      init: function() {
        console.log("calc init");
      },
      finalize: function () {
        console.log("calc finalize");
      }
    },
	  
    'v1_radar_detector_apps': {
      init: function() {
        //console.log("test1");
		  
		 $('.screen1').mouseover(function(){
			 $('img.screens').attr('src', '/wp-content/uploads/2019/12/appscreen1.png');}
		 ); 
		 $('.screen2').mouseover(function(){
			 $('img.screens').attr('src', '/wp-content/uploads/2019/12/appscreen2.png');}
		 ); 
		 $('.screen3').mouseover(function(){
			 $('img.screens').attr('src', '/wp-content/uploads/2019/12/appscreen3.png');}
		 ); 
		 $('.screen4').mouseover(function(){
			 $('img.screens').attr('src', '/wp-content/uploads/2019/12/appscreen4.png');}
		 ); 		  
		  
		  
		  
      },
      finalize: function () {
        console.log("calc finalize");
      }
    },	  
	  
	  
	  

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
